import { getStoreId } from "$/hooks/use-store-information"
import emergencyServicePricesQueries from "$/lib/queries/emergency-service-queries.ts"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/emergency-service")(
  {
    loader: async ({ context: { queryClient } }) => {
      const storeId = await getStoreId()
      if (storeId)
        queryClient.prefetchQuery(emergencyServicePricesQueries.list(storeId))
      return {
        crumbs: "alfred.settings.crumbs.emergencyService",
      }
    },
  },
)
